import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { ProgressBarProps } from './models';
import * as styles from './styles';
import { useTranslation } from '@sunbit-dev/translations';

const ProgressBar = styled(({ className, step, dataTestId }: ProgressBarProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'progress_bar' });
  const titles = t('titles', { returnObjects: true }) as string[];

  return (
    <div {...{ className, 'data-testid': dataTestId }}>
      {titles?.map((title, index) => (
        <React.Fragment key={`steper_${index}`}>
          <div className="step">
            <div
              {...{
                'data-textbefore': (index + 1).toString(),
                className: classNames('circle', step > index ? 'checked' : step == index ? 'done' : ''),
              }}
            />
            <div className={classNames('title', { done: step === index })}>
              <p>{title}</p>
            </div>
          </div>
          {titles?.length - 1 > index && <div {...{ className: classNames('bar', { done: step > index }) }} />}
        </React.Fragment>
      ))}
    </div>
  );
})`
  ${styles.ProgressBar}
`;

export { ProgressBar };
